import { Form, FormInstance, Input } from 'antd'
import { useEffect, useState } from 'react'
import { debounce } from 'utils/common'

import Editor from 'components/features/editor/QuillEditor'

interface IFormContentProps {
  form: FormInstance
  lang: string
  dataSource: any
}

const FormContent = ({ form, lang, dataSource }: IFormContentProps) => {
  const [content, setContent] = useState<string>()

  useEffect(() => {
    if (dataSource?.id) {
      form.setFieldValue(lang, dataSource)
      setContent(dataSource.contentHtml)
    } else {
      setContent(' ')
    }
  }, [])

  const rteChange = debounce(function (value: any) {
    setContent(value)
  }, 10)

  return (
    <>
      <div className='form-social'>
        <Form.Item name={[lang, 'id']} className='hidden'>
          <Input hidden />
        </Form.Item>
        <Form.Item name={[lang, 'locale']} className='hidden'>
          <Input hidden />
        </Form.Item>
        <Form.Item name={[lang, 'pageName']} className='hidden'>
          <Input hidden />
        </Form.Item>
        <Form.Item name={[lang, 'pageType']} className='hidden'>
          <Input hidden />
        </Form.Item>

        <Form.Item
          name={[lang, 'contentHtml']}
          validateTrigger={['onChange', 'onBlur']}
          rules={[
            {
              required: true,
              whitespace: true,
              message: `please input content ${lang.toUpperCase()}`,
            },
          ]}
        >
          {!!content && (
            <Editor
              content={content}
              onChange={(value) => rteChange(value)}
              image={true}
              folder={'staticPages/webconfig'}
              className='editor-content sticky-content'
            />
          )}
        </Form.Item>
      </div>
    </>
  )
}

export default FormContent
